import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const convertedFiles: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_S2I_API}/get-files`),
};

export default convertedFiles;
